<div class="grid-fluid" [ngClass]="{'bg-black text-white': data.settings?.theme === 'dark'}">
  <div class="cell">
    <div class="grid align-center padding-horizontal-medium padding-bottom-medium document-template padding-vertical-xbig">
      <div class="cell cell-large-col-span-12 text-center">
        <h1 class="display-small text-center" [ngClass]="{'text-white': data.settings?.theme === 'dark'}">{{ data.settings?.heading }}</h1>
        <div class="text-small margin-top-small" [ngClass]="{'text-white': data.settings?.theme === 'dark'}" *ngIf="data.settings?.subtext" [innerHTML]="data.settings?.subtext"></div>
      </div>
      <ng-container [ngSwitch]="data.layout">
        <ng-container *ngSwitchCase="'image'">
          <div class="cell flex flex-column cell-medium-col-span-4 icon padding-vertical-small" [ngClass]="'cell-large-col-span-' + data.settings?.columns" *ngFor="let card of data.settings?.cards">
            <div class="product-card-grid-image margin-bottom-xsmall" [innerHTML]="card.image"></div>
            <span class="mat-title" [ngClass]="{'text-white': data.settings?.theme === 'dark'}">{{ card.title }}</span>
            <p class="body margin-bottom-none" [innerHTML]="card.content"></p>
            <mat-chip-set class="margin-bottom-xxsmall margin-top-small" *ngIf="card.capsules">
              <mat-chip *ngFor="let capsule of card.capsules" class="text-small" [ngStyle]="{'background-color': capsule.theme, color: 'white'}">{{capsule.label}}</mat-chip>
            </mat-chip-set>
          </div>
        </ng-container>
        <ng-container *ngSwitchCase="'icon'">
          <div class="cell flex flex-column cell-medium-col-span-4 icon padding-medium" [ngClass]="'cell-large-col-span-' + data.settings?.columns" *ngFor="let card of data.settings?.cards">
            <div class="product-card-grid-image-icon">
              <open-svg-icon [name]="card.image" class="medium" [ngClass]="{'dark' : data.settings?.theme === 'dark'}"></open-svg-icon>
            </div>
            <span class="mat-title margin-bottom-small" [ngClass]="{'text-white': data.settings?.theme === 'dark'}">{{ card.title }}</span>
            <p class="body margin-bottom-none" [innerHTML]="card.content"></p>
            <mat-chip-set class="margin-bottom-xxsmall margin-top-small">
              <mat-chip *ngFor="let capsule of card.capsules" class="text-small" [ngStyle]="{'background-color': capsule.theme, color: 'white'}">{{capsule.label}}</mat-chip>
            </mat-chip-set>
          </div>
        </ng-container>
        <ng-container *ngSwitchCase="'highlight'">
          <div class="cell flex flex-column product-card-highlight padding-xmedium open-section cell-medium-col-span-6" [ngClass]="'cell-large-col-span-' + data.settings?.columns" *ngFor="let card of data.settings?.cards">
            <h5 class="margin-bottom-small">{{ card.category }}</h5>
            <div class="margin-bottom-medium product-card-grid-image">
              <div class="product-card-grid-image-logo">
                <img [src]="data.settings?.brandIcon" width="48" height="48">
              </div>
              <div class="height-ful product-card-highlight-image">
                <img [src]="card.image">
              </div>
            </div>
            <span class="mat-title margin-bottom-small product-card-highlight-title" [ngClass]="{'text-white': data.settings?.theme === 'dark'}" [innerHTML]="card.title"></span>
            <span class="input-large product-card-highlight-content" [innerHTML]="card.content"></span>

            <div *ngIf="card.buttons">
              <button (click)="startQuoteEvent.emit(button.link)" *ngFor="let button of card.buttons" mat-flat-button color="primary" class="margin-top-xmedium margin-bottom-xsmall width-full">{{ button.label }}</button>
            </div>

            <a *ngFor="let link of card.links" href="" (click)="onClick(link.link, $event)" class="product-card-highlight-link strong-small" color="primary">{{ link.label }}</a>
          </div>
        </ng-container>
      </ng-container>
      <div class="cell cell-large-col-span-12 text-center">
        <button *ngFor="let button of data.settings?.buttons" (click)="startQuoteEvent.emit(button.link)" mat-flat-button color="primary" class="margin-right-xsmall hero-banner-button margin-bottom-xsmall">{{ button.label }}</button>
        <p [innerHTML]="data.settings?.disclaimer" class="margin-bottom-none small" [ngClass]="{'text-white': data.settings?.theme === 'dark', 'text-darkGray': data.settings?.theme !== 'dark'}"></p>
      </div>
    </div>
  </div>
</div>